import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#707070",
    viewBox: "0 0 80 80",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<circle cx="40" cy="40" r="38" stroke="#243E81" stroke-width="2" fill="#EDF1F5"/> <path fill="#edf1f5" stroke="#243E81" stroke-width="2" d="M33.39 26.991a4.067 4.067 0 1 1-8.134 0 4.067 4.067 0 0 1 8.134 0zm22.278 0a4.067 4.067 0 1 1-8.134 0 4.067 4.067 0 0 1 8.134 0zM37.24 42.675v14.506H21.417V41.676a6.13 6.13 0 0 1 6.13-6.13h3.551a6.13 6.13 0 0 1 6.129 6.13v1h.013zm22.278 0v14.506H43.695V41.676a6.13 6.13 0 0 1 6.13-6.13h3.551a6.13 6.13 0 0 1 6.129 6.13v1h.013z"/> <path stroke="#fff" stroke-width="6" d="m29 51 22-22m-22 0 22 22"/> <path fill="#edf1f5" stroke="#243E81" stroke-width="3" d="m30 50 20-20m-20 0 20 20"/>' }
  })
);